// The one ServiceLad footer, the partner of slHeader.js. React renders it
// through SlCloudFooter.jsx; vehicle, makes and prerendered pages call
// slFooterHtml(). Same markup and CSS everywhere. Plain JS, no JSX.

import { serviceLadLogoHtml } from "../../../lib/brandLogo.js";

export const SL_FOOTER_COLUMNS = [
  {
    title: "Free checks",
    links: [
      { label: "Check a vehicle", href: "/vehicle-check" },
      { label: "Free car check", href: "/free-car-check" },
      { label: "Road tax calculator", href: "/car-tax-calculator/" },
      { label: "ULEZ checker", href: "/ulez-checker" },
      { label: "Insurance group", href: "/insurance-groups" },
    ],
  },
  {
    title: "Logbook and reports",
    links: [
      { label: "V5C logbook alerts", href: "/v5c-alerts" },
      { label: "Pricing", href: "/pricing" },
      { label: "Cheapest HPI check", href: "/cheapest-hpi-check" },
      { label: "Lost your V5C?", href: "/guides/lost-v5c-what-to-do" },
      { label: "V5C alerts explained", href: "/guides/v5c-and-logbook-alerts-explained" },
    ],
  },
  {
    title: "Guides",
    links: [
      { label: "All guides", href: "/guides/" },
      { label: "SORN explained", href: "/guides/sorn-explained" },
      { label: "MOT checks before the test", href: "/guides/basic-mot-checks-before-the-test" },
      { label: "ULEZ explained", href: "/guides/ulez-explained" },
    ],
  },
  {
    title: "ServiceLad",
    links: [
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
      { label: "Terms", href: "/terms" },
      { label: "Privacy", href: "/privacy" },
    ],
  },
];

// What ServiceLad is, in one short line (owner's wording, 22 Oct 2026).
const FOOTER_BLURB = "ServiceLad provides full vehicle checks, plus dealer service history for supported makes. Free tax and MOT lookups, one-off payments.";

export function slFooterHtml({ withStyles = true, year = new Date().getFullYear() } = {}) {
  const columns = SL_FOOTER_COLUMNS.map((column) => `<div class="slf-col"><p class="slf-title">${column.title}</p><ul>${column.links.map((link) => `<li><a href="${link.href}">${link.label}</a></li>`).join("")}</ul></div>`).join("");
  return `${withStyles ? `<style>${SL_FOOTER_CSS}</style>` : ""}<footer class="slf"><div class="slf-inner"><div class="slf-top"><div class="slf-brand"><a class="slf-logo" href="/" aria-label="ServiceLad home">${serviceLadLogoHtml(22)}</a><p>${FOOTER_BLURB}</p><a class="slf-mail" href="mailto:info@servicelad.co.uk">info@servicelad.co.uk</a></div><nav class="slf-cols" aria-label="Footer">${columns}</nav></div><div class="slf-bottom"><span>&copy; ${year} ServiceLad</span><span>Vehicle details come from DVLA and DVSA records. ServiceLad is not part of DVLA or DVSA.</span></div></div></footer>`;
}

// Self-contained like SL_HEADER_CSS, so page styles cannot change it.
export const SL_FOOTER_CSS = `.slf{position:relative;z-index:1;margin:0;padding:0;border-top:1px solid rgba(15,23,42,.08);background:#f8fafc;color:#475569;font-family:"Figtree",system-ui,-apple-system,"Segoe UI",sans-serif;font-size:14px;line-height:1.5;text-align:left}
.slf *{box-sizing:border-box}
.slf .slf-inner{width:min(100% - 32px,72rem);margin:0 auto;padding:44px 0 26px}
.slf .slf-top{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,3fr);gap:40px}
.slf .slf-logo{display:inline-flex;line-height:0;text-decoration:none}
.slf .slf-brand p{max-width:300px;margin:14px 0 10px;color:#64748b;font-size:14px}
.slf .slf-mail{color:#2563eb;font-weight:600;text-decoration:none}
.slf .slf-cols{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:24px}
.slf .slf-title{margin:0 0 12px;color:#0f172a;font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase}
.slf ul{margin:0;padding:0;list-style:none}
.slf li{margin:0 0 9px}
.slf .slf-cols a{color:#475569;text-decoration:none;transition:color .15s}
.slf .slf-cols a:hover,.slf .slf-mail:hover{color:#0f172a}
.slf .slf-bottom{display:flex;flex-wrap:wrap;justify-content:space-between;gap:8px 24px;margin-top:36px;padding-top:18px;border-top:1px solid rgba(15,23,42,.08);color:#94a3b8;font-size:12.5px}
@media (max-width:900px){.slf .slf-top{grid-template-columns:1fr;gap:28px}.slf .slf-cols{grid-template-columns:repeat(2,minmax(0,1fr));gap:24px 20px}}
@media (max-width:640px){.slf .slf-inner{padding-top:34px}.slf .slf-logo img{width:180px!important;height:20px!important}}`;
